import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const startUpFn = () => {
    if (typeof Zone > "u") {
        return false;
    }
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
    return true;
};
if (!startUpFn()) {
    let intid = setInterval(() => {
        if (startUpFn()) {
            clearInterval(intid);
        }
    }, 10);
}
